module.exports = {
  dimensions: {
    width: 327,
    height: 310
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};